function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, React.createElement("path", {
  fill: "#fff",
  d: "M7.99.368V1.84H4.753v10.505H3.144V1.84H0V.368zM19.79 12.345l-2.83-4.434h-2.163v4.416h-1.628V.367l3.2.001a5.463 5.463 0 0 1 2.127.423 3.547 3.547 0 0 1 1.516 1.27c.381.598.574 1.297.555 2.005a4.177 4.177 0 0 1-.5 2.042 3.193 3.193 0 0 1-1.497 1.417l3.033 4.82H19.79zm-1.294-6.642a2.33 2.33 0 0 0 .573-1.563 2.4 2.4 0 0 0-.24-1.05 2.12 2.12 0 0 0-.777-.845 2.358 2.358 0 0 0-1.406-.405h-1.85v4.526h1.758c.715.084 1.43-.16 1.942-.663zM54.729.368v12.363l-8.897-8.923v8.537h-1.627V0l8.822 9.033V.368zM59.907.368H63.2a7.114 7.114 0 0 1 3.699.883 5.402 5.402 0 0 1 2.145 2.281c.457.921.691 1.936.685 2.962a5.863 5.863 0 0 1-.814 3.073 5.666 5.666 0 0 1-2.183 2.042 6.297 6.297 0 0 1-2.96.736H59.89L59.907.368zm3.57 10.413a5.462 5.462 0 0 0 2.367-.515 3.876 3.876 0 0 0 1.647-1.527 4.617 4.617 0 0 0 .591-2.373 4.617 4.617 0 0 0-.61-2.41 4.227 4.227 0 0 0-1.646-1.527 4.773 4.773 0 0 0-2.201-.59h-2.109v8.942h1.961z"
}), React.createElement("path", {
  fill: "#FFCB6F",
  d: "M35.015 7.286h-9.019V5.464h9.019z"
}), React.createElement("path", {
  fill: "#FFB917",
  d: "M38.729 2.082H25.996V.26h12.733z"
}), React.createElement("path", {
  fill: "#FEDEA7",
  d: "M32.628 12.49H26.26v-1.822h6.367z"
}));

const SvgComponent = props => React.createElement("svg", _extends({
  width: 70,
  height: 13,
  viewBox: "0 0 70 13"
}, props), _ref);

export default __webpack_public_path__ + "static/media/trend-logo-web.1765e15e.svg";
export { SvgComponent as ReactComponent };